<template>
  <v-col class="tes-card" white>
    <div>
      <v-tabs slider-color="#ff721c">
        <v-tab
          v-for="tab in tabs"
          :key="tab.to"
          class="fs-18"
          :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'"
          :to="tab.to"
        >{{tab.title}}</v-tab>
      </v-tabs>
      <slot></slot>
    </div>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PersonalInformationTabs",
  computed: {
    ...mapGetters("locale",["currentLocale"]),

    tabs(){ 
      return [
      {
        title: this.$t('pages.personalInformation.title'),
        to: "/settings/personal-information"
      },
      {
        title: this.$t('pages.additionalAccounts.title'),
        to: "/settings/additional-accounts"
      },
      {
        title: this.$t('pages.changePassword.title'),
        to: "/settings/change-password"
      }
    ]
    }
  },
  data: () => ({
  }),
  methods: {}
};
</script>
<style lang="scss">
a.v-tab {
  padding-left: 30px;
  padding-right: 30px;
}

a.v-tab.v-tab--active {
  color: white;
  background: $orange-gradient-horizontal;
}

.v-tabs {
  border-bottom: solid 1px;
}

.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  @media screen and (max-width: 992px) {
    display: none;
  }
}
</style>
